import { Shield, Users, Hammer, MessageSquare, DollarSign, CheckCircle } from 'lucide-react';

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: Hammer,
      title: 'Built Right. Built to Last.',
      description: 'We focus on durability and quality craftsmanship that stands the test of time.',
    },
    {
      icon: Users,
      title: 'Local Calgary Company',
      description: 'We understand local homes, building codes, and standards specific to Alberta.',
    },
    {
      icon: CheckCircle,
      title: 'Clean, Professional Work',
      description: 'Attention to detail and finishing that meets the highest standards.',
    },
    {
      icon: MessageSquare,
      title: 'Reliable Communication',
      description: 'Clear timelines, regular updates, and responsive project management.',
    },
    {
      icon: DollarSign,
      title: 'Transparent Pricing',
      description: 'Detailed quotes with no hidden costs or surprise charges.',
    },
    {
      icon: Shield,
      title: 'Fully Insured',
      description: 'Complete liability coverage and WCB for safe, protected work.',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="why-choose-us-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#c5a059] text-sm uppercase tracking-[0.3em] mb-4">
            Our Commitment
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#0f172a] mb-6">
            Why Choose YYC Custom Basement & Bath
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            We're committed to delivering exceptional quality and service on every project.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group p-8 bg-[#f8f9fa] hover:bg-[#0f172a] transition-all duration-300"
              data-testid={`why-choose-item-${index}`}
            >
              <div className="w-14 h-14 bg-white flex items-center justify-center mb-6 group-hover:bg-[#c5a059] transition-colors">
                <reason.icon className="w-7 h-7 text-[#c5a059] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-[#0f172a] group-hover:text-white mb-3 transition-colors">
                {reason.title}
              </h3>
              <p className="text-slate-600 group-hover:text-slate-300 transition-colors leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
